import React from "react";
import { Link } from "react-router-dom";
import { CLASSIC_SITE_BASE } from "../classicSite.constants";

export default function ClassicSiteHomePage() {
  return (
    <div className="cs-home">
      <h1>Classic Site React Silo</h1>
      <p className="cs-home__lead">
        Isolated preview for Django <code>classic_site</code> parity. HomePageV2
        and twentytwentysix marketing are out of scope.
      </p>

      <div className="cs-home__grid">
        <section className="cs-card">
          <h2>Public reads (hoodie API)</h2>
          <ul>
            <li>
              <Link to={`${CLASSIC_SITE_BASE}/public/listings`}>Listings</Link>
            </li>
            <li>
              <Link to={`${CLASSIC_SITE_BASE}/public/events`}>Events</Link>
            </li>
            <li>
              <Link to={`${CLASSIC_SITE_BASE}/public/promos`}>Promos</Link>
            </li>
          </ul>
        </section>

        <section className="cs-card">
          <h2>Member portal</h2>
          <p>Billing, subscriptions, and listing CRUD shells with blocked states.</p>
          <Link to={`${CLASSIC_SITE_BASE}/member`}>Member section →</Link>
        </section>

        <section className="cs-card">
          <h2>Admin parity</h2>
          <p>Matrix from <code>classic_site/admin.py</code> — no REST admin API.</p>
          <Link to={`${CLASSIC_SITE_BASE}/admin`}>Admin section →</Link>
        </section>
      </div>

      <section className="cs-card cs-home__specs">
        <h2>Planning artifacts</h2>
        <ul>
          <li><code>project-ops/specs/classic-site-react-silo-plan-v1.md</code></li>
          <li><code>project-ops/specs/classic-site-react-member-parity-matrix-v1.md</code></li>
          <li><code>project-ops/specs/classic-site-react-admin-parity-matrix-v1.md</code></li>
          <li><code>project-ops/specs/classic-site-react-api-gap-register-v1.md</code></li>
        </ul>
      </section>
    </div>
  );
}
